export default "__VITE_ASSET__DLISjWMB__"